import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Common";
import { ScrollText, Loader2 } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)).catch(() => setLogs([])); }, []);

  return (
    <div className="animate-fade-up">
      <PageHeader title="Audit Log" subtitle="Every action performed through the portal" icon={ScrollText} />
      <div className="glass rounded-3xl p-4">
        {logs === null ? <div className="flex justify-center p-10 text-emerald-600"><Loader2 className="h-6 w-6 animate-spin" /></div> :
          logs.length === 0 ? <EmptyState label="No activity recorded yet" /> :
          <div className="space-y-2">
            {logs.map((l) => (
              <div key={l.id} className="flex items-center justify-between rounded-2xl bg-white/60 p-3" data-testid={`audit-${l.id}`}>
                <div>
                  <p className="text-sm font-medium capitalize text-slate-800">{l.operation.replace(/_/g, " ")}</p>
                  <p className="text-xs text-slate-500">{JSON.stringify(l.detail)}</p>
                </div>
                <div className="text-right text-xs text-slate-400"><p>{l.actor}</p><p>{new Date(l.created_at).toLocaleString()}</p></div>
              </div>
            ))}
          </div>}
      </div>
    </div>
  );
}
